import {
  AllessehQueryRules,
  AllessehQuerySortKeyTypes,
  AllessehQuerySortOrderType
} from 'hooks/useAllessehContentQuery';

export const DEFAULT_PRODUCT_VALUE = ['WSJ.com'];

export const ruleNewsPlus = { terms: { key: 'Keyword', value: ['newsplus'] } };

export const COMMON_QUERY_RULES_CONFIG: AllessehQueryRules = {
  and: [{ terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }],
  not: [
    {
      terms: {
        key: 'SectionName',
        value: [
          'Breaking News China Traditional',
          'Corrections and Amplifications',
          'Decos and Corrections',
          'Direct Push Alert',
          'DJON Wire',
          'NewsPlus',
          'WSJ Puzzles',
          'Opinion',
          'WSJPRO'
        ]
      }
    },
    {
      terms: {
        key: 'SectionType',
        value: [
          'Breaking News China Simplified',
          'Board Pack Exclusive',
          'Cryptic',
          'Crossword',
          'Crossword Contest',
          'Deco Summary (Content)',
          'Deco Summary (Plain)',
          'Deco Summary Barrons Cover Story',
          'Deco Summary Barrons Market Week',
          'Deco Summary Barrons Preview',
          'Deco Summary Japanese',
          'Deco Summary Liondoor',
          'Infogrfx Slide Show',
          'Infogrfx House Of The Day',
          'Pepper%20%26%20Salt',
          'Pro Bankruptcy Data Tables',
          'Recipes',
          'Style & Substance',
          'Whats News',
          'Whats News Business Finance',
          'Whats News World Wide'
        ]
      }
    }
  ]
};

export const DEFAULT_SORT_CONFIG = [
  { key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }
];

export const COMMON_VIDEO_QUERY_RULES_CONFIG: AllessehQueryRules = {
  and: [
    { term: { key: 'ContentType', value: 'video' } },
    { terms: { key: 'Product', value: ['wsj video', 'wsj opinion video', 'wsj opinion video podcast'] } },
    { term: { key: 'LanguageCode', value: 'en' } }
  ]
};

export const VIDEO_WSJ_NETWORK_QUERY_RULES_CONFIG: AllessehQueryRules = {
  and: [
    { term: { key: 'ContentType', value: 'video' } },
    { terms: { key: 'Product', value: ['wsjdn premium video', 'wsj opinion video', 'wsj opinion video podcast'] } },
    { term: { key: 'LanguageCode', value: 'en' } }
  ]
};

export const COMMON_RELATED_OPINION_QUERY_RULES_CONFIG: AllessehQueryRules = {
  and: [
    {
      term: {
        value: 'opinion',
        key: 'PrimaryDJEThing'
      }
    },
    { terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }
  ]
};

export const COMMON_QUERY_CONFIG = {
  sort: DEFAULT_SORT_CONFIG
};

export const DEFAULT_LIMIT = 5;

export const DEFAULT_SECTION_TOP_COUNT = {
  count: 1
};

export const BASE_QUERY = {
  query: {
    and: [{ terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }],
    not: [
      {
        terms: {
          key: 'SectionName',
          value: [
            'Breaking News China Traditional',
            'Corrections and Amplifications',
            'Decos and Corrections',
            'Direct Push Alert',
            'DJON Wire',
            'NewsPlus',
            'WSJ Puzzles',
            'Opinion',
            'WSJPRO'
          ]
        }
      },
      {
        terms: {
          key: 'SectionType',
          value: [
            'Breaking News China Simplified',
            'Board Pack Exclusive',
            'Cryptic',
            'Crossword',
            'Crossword Contest',
            'Deco Summary (Content)',
            'Deco Summary (Plain)',
            'Deco Summary Barrons Cover Story',
            'Deco Summary Barrons Market Week',
            'Deco Summary Barrons Preview',
            'Deco Summary Japanese',
            'Deco Summary Liondoor',
            'Infogrfx Slide Show',
            'Infogrfx House Of The Day',
            'Pepper%20%26%20Salt',
            'Pro Bankruptcy Data Tables',
            'Recipes',
            'Style & Substance',
            'Whats News',
            'Whats News Business Finance',
            'Whats News World Wide'
          ]
        }
      }
    ]
  },
  sort: [{ key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }],
  count: DEFAULT_LIMIT
};

export const BASE_QUERY_PRO = {
  query: {
    and: [{ terms: { key: 'Product', value: [...DEFAULT_PRODUCT_VALUE, 'WSJPRO'] } }],
    not: [
      {
        terms: {
          key: 'SectionName',
          value: [
            'Breaking News China Traditional',
            'Corrections and Amplifications',
            'Decos and Corrections',
            'Direct Push Alert',
            'DJON Wire',
            'NewsPlus',
            'WSJ Puzzles',
            'Opinion'
          ]
        }
      },
      {
        terms: {
          key: 'SectionType',
          value: [
            'Breaking News China Simplified',
            'Board Pack Exclusive',
            'Cryptic',
            'Crossword',
            'Crossword Contest',
            'Deco Summary (Content)',
            'Deco Summary (Plain)',
            'Deco Summary Barrons Cover Story',
            'Deco Summary Barrons Market Week',
            'Deco Summary Barrons Preview',
            'Deco Summary Japanese',
            'Deco Summary Liondoor',
            'Infogrfx Slide Show',
            'Infogrfx House Of The Day',
            'Pepper%20%26%20Salt',
            'Pro Bankruptcy Data Tables',
            'Recipes',
            'Style & Substance',
            'Whats News',
            'Whats News Business Finance',
            'Whats News World Wide'
          ]
        }
      }
    ]
  },
  sort: [{ key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }],
  count: DEFAULT_LIMIT
};
